const onlyNumbersString = (str) => {
  if (!str) return null

  return str.replace(/\D/g, '')
}

export default onlyNumbersString
